import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getAgreementDocuments: {
        method: 'GET',
        url: `${BASE_PATH_API}/public/agreementDocuments/:documentType`
    },
    publicUpsertUserAgreement: {
        method: 'PUT',
        url: `${BASE_PATH_API}/public/userAgreements`
    },
    getUserAgreement: {
        method: 'GET',
        url: `${BASE_PATH_API}/userAgreement`
    },
    getUserAgreementByUserId: {
        method: 'GET',
        url: `${BASE_PATH_API}/userAgreement/users/:userId`
    },
    updateUserAgreement: {
        method: 'PUT',
        url: `${BASE_PATH_API}/userAgreement`
    },
    publicGetUserAgreementStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/public/userAgreements/status`
    },
    publicFacingTermsOfUseUrl: {
        method: 'GET',
        url: `${BASE_PATH_API}/public/userAgreements/termsOfUseUrl`
    }
};

export function UserAgreementsApi() {
    return createActions(actions);
}
